<div>
  <h3>{{ 'pleaseChooseWhatYouWantToCreate' | translate }}</h3>
  <span>
    <app-ui-button
      [text]="'component' | translate"
      (click)="createComponent()"
      [privilege]="Privileges.ComponentCreate"
    ></app-ui-button>
    <app-ui-button
      [text]="'componentGroup' | translate"
      (click)="createComponentGroup()"
      [privilege]="Privileges.ComponentGroupCreate"
    ></app-ui-button>
  </span>
</div>
